<template>
  <no-auth v-if="!hasAuthorize.calculate"></no-auth>

  <div class="container-fluid o-card" v-else>
    <h4>
      {{ $t("navigation.vincCalculating") }}
    </h4>
    <hr />
    <div class="row">
      <div class="es-xs-12 es-sm-4">
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.potDimensions") }}
          </h6>
          <BaseInput
            v-model="form.potDiameter"
            :label="$t('vincCalculating.potDiameter')"
            block
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            suffix="m"
            type="number"
            :placeholder="$t('vincCalculating.potDiameter')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.potHeight"
            :label="$t('vincCalculating.potHeight')"
            block
            suffix="m"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.potHeight')"
            mandotary
          ></BaseInput>
        </div>
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.glassDimensions") }}
          </h6>
          <BaseInput
            v-model="form.cabinHeight"
            :label="$t('vincCalculating.cabinHeight')"
            block
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            suffix="m"
            :placeholder="$t('vincCalculating.cabinHeight')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.frontGlassHeight"
            :label="$t('vincCalculating.frontGlassHeight')"
            block
            suffix="m"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.frontGlassHeight')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.sideGlassHeight"
            :label="$t('vincCalculating.sideGlassHeight')"
            block
            suffix="m"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.sideGlassHeight')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.metalWidth"
            :label="$t('vincCalculating.metalWidth')"
            block
            suffix="m"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.metalWidth')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.wallThickness"
            :label="$t('vincCalculating.wallThickness')"
            block
            suffix="mm"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.wallThickness')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.insulationThickness"
            :label="$t('vincCalculating.insulationThickness')"
            block
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            suffix="mm"
            :placeholder="$t('vincCalculating.insulationThickness')"
            mandotary
          ></BaseInput>
        </div>
        <div class="u-margin-bottom-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.insulationDimensions") }}
          </h6>
          <BaseInput
            v-model="form.outdoorTemperature"
            :label="$t('vincCalculating.outdoorTemperature')"
            block
            suffix="°C"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.outdoorTemperature')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="form.cabinTemperature"
            :label="$t('vincCalculating.cabinTemperature')"
            block
            suffix="°C"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="$t('vincCalculating.cabinTemperature')"
            mandotary
          ></BaseInput>
        </div>
        <Button block variant="warning" @click="calculate">
          {{ $t("vincCalculating.calculate") }}
        </Button>
      </div>
      <div class="es-xs-12 es-sm-4">
        <div class="u-margin-bottom">
          <img
            :src="require(`@/assets/images/${$i18n.locale}/kabin-pota.png`)"
            width="100%"
            alt="kabin pota"
          />
        </div>
        <div v-if="result.status" id="result">
          <BaseInput
            :label="$t('vincCalculating.totalGlasses')"
            v-model="result.totalGlasses"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            block
            readonly
            disabled
            size="xs"
          ></BaseInput>
          <BaseInput
            :label="$t('vincCalculating.totalWalls')"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            v-model="result.totalWalls"
            block
            readonly
            disabled
            size="xs"
          ></BaseInput>
          <BaseInput
            :label="$t('vincCalculating.cabinTotalThermalLoad')"
            v-model="result.cabinTotalThermalLoad"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            block
            readonly
            suffix="kW"
            disabled
            size="xs"
          ></BaseInput>
          <BaseInput
            v-if="hasAuthorize.add"
            class="u-margin-top-small"
            :label="$t('vincCalculating.title')"
            v-model="title"
            block
            disabled
            size="sm"
          ></BaseInput>
          <div class="u-display-flex">
            <Button
              v-if="hasAuthorize.add"
              block
              :disabled="!title"
              variant="primary"
              class="u-margin-top"
              @click="save"
            >
              {{ $t("common.save") }}
            </Button>
            <Button
              block
              variant="danger "
              class="u-margin-top"
              @click="creatingPdf = true"
            >
              {{ $t("common.printCalculation") }}
            </Button>
          </div>
          <div>
            <router-link v-if="!creatingPdf" :to="{ name: 'cycles-selection' }">
              <Button block variant="primary" class="u-margin-top">
                {{ $t("cycles.selection2") }}
              </Button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="es-xs-12 es-sm-4">
        <div class="u-background-color-white o-card__padding-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("vincCalculating.automaticValues") }}
          </h6>
          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaKabinYatayUzaklik"
                :label="$t('vincCalculating.potaKabinYatayUzaklik')"
                block
                readonly
                disabled
                suffix="m"
                size="xs"
                :value="10"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaKabinYukseklik"
                :label="$t('vincCalculating.potaKabinYukseklik')"
                block
                readonly
                disabled
                suffix="m"
                size="xs"
                :value="15"
              ></BaseInput>
            </div>
          </div>

          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYuzeyiSicakligi"
                :label="$t('vincCalculating.potaYuzeyiSicakligi')"
                block
                readonly
                disabled
                suffix="°C"
                size="xs"
                :value="1473.15"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYuzeyiYaymaOrani"
                block
                readonly
                disabled
                size="xs"
                :label="$t('vincCalculating.yalitimliAlanOrani')"
                :value="0.9"
                suffix="°C"
              ></BaseInput>
            </div>
          </div>
          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYanYuzeySicakligi"
                :label="$t('vincCalculating.potaYanYuzeySicakligi')"
                block
                readonly
                disabled
                suffix="°C"
                size="xs"
                :value="973.15"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.potaYanYuzeyYaymaOrani"
                block
                readonly
                disabled
                size="xs"
                :label="$t('vincCalculating.yalitimliAlanOrani')"
                :value="0.9"
                suffix="°C"
              ></BaseInput>
            </div>
          </div>
          <BaseInput
            v-model="automaticValues.yalitimliAlanOrani"
            :label="$t('vincCalculating.yalitimliAlanOrani2')"
            block
            readonly
            disabled
            size="xs"
            :value="0.8"
          ></BaseInput>

          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.disOrtamTasinimKatsayisi"
                :label="$t('vincCalculating.disOrtamTasinimKatsayisi')"
                block
                readonly
                disabled
                suffix="W/m².K"
                size="xs"
                :value="30"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.kabinOrtamiTasinimKatsayisi"
                :label="$t('vincCalculating.kabinOrtamiTasinimKatsayisi')"
                block
                readonly
                disabled
                suffix="W/m².K"
                size="xs"
                :value="25"
              ></BaseInput>
            </div>
          </div>
          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.duvarYaymaOrani"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                :label="
                  $t('vincCalculating.duvarYaymaOrani') +
                  ' / ' +
                  $t('vincCalculating.duvarGecirmeOrani')
                "
                block
                readonly
                disabled
                size="xs"
                :value="0.8"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-2">
              <BaseInput
                v-model="automaticValues.duvarGecirmeOrani"
                block
                readonly
                disabled
                size="xs"
                :value="0"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-2">
              <BaseInput
                v-model="automaticValues.duvarYaymaOrani"
                block
                readonly
                disabled
                size="xs"
                :value="0.8"
              >
              </BaseInput>
            </div>
            <div class="es-xs-12 es-md-2">
              <BaseInput
                v-model="automaticValues.duvarGecirmeOrani"
                block
                readonly
                disabled
                size="xs"
                :value="0"
              ></BaseInput>
            </div>
          </div>

          <div class="row">
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.metalSacIsiIletimKatsayisi"
                :label="$t('vincCalculating.metalSacIsiIletimKatsayisi')"
                block
                readonly
                disabled
                suffix="W/m.K"
                size="xs"
                :value="54"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-md-6">
              <BaseInput
                v-model="automaticValues.tasYunu"
                :label="$t('vincCalculating.tasYunu')"
                block
                readonly
                disabled
                suffix="W/m.K"
                size="xs"
                :value="0.042"
              ></BaseInput>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Detail
      v-if="creatingPdf"
      :title="title"
      :form="form"
      :result="result"
      auto-print
      @pdfCreated="creatingPdf = false"
    ></Detail>
  </div>
</template>

<script>
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Button from "@/components/Base/Button.vue";
import Requests from "@/services/Requests";
import Detail from "./Detail.vue";
import authorize from "./authorize";
export default {
  components: {
    BaseInput,
    Button,
    Detail,
  },
  mixins: [authorize],
  data() {
    return {
      title: "",
      creatingPdf: false,
      form: {
        potDiameter: 0,
        potHeight: 0,
        frontGlassHeight: 0,
        sideGlassHeight: 0,
        metalWidth: 0,
        outdoorTemperature: 0,
        cabinTemperature: 0,
        wallThickness: 0,
        insulationThickness: 0,
        cabinHeight: 0,
      },
      automaticValues: {
        potaKabinYatayUzaklik: 10,
        potaKabinYukseklik: 15,
        potaYuzeyiSicakligi: 1473.15,
        potaYuzeyiYaymaOrani: 0.8,
        potaYanYuzeySicakligi: 973.15,
        potaYanYuzeyYaymaOrani: 0.9,
        yalitimliAlanOrani: 0.8,
        disOrtamTasinimKatsayisi: 30,
        kabinOrtamiTasinimKatsayisi: 25,
        duvarYaymaOrani: 0.8,
        duvarGecirmeOrani: 0,
        metalSacIsiIletimKatsayisi: 54,
        tasYunu: 0.042,
      },
      result: {
        status: false,
        totalGlasses: 0,
        totalWalls: 0,
        cabinTotalThermalLoad: 0,
      },
    };
  },
  methods: {
    VALIDATION_ERROR_MESSAGE(message) {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: false,
        status: true,
        message: message,
        variant: "danger",
        duration: 2500,
      });
      return true;
    },
    validation() {
      if (!this.form.potDiameter)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.potDiameter"),
          })
        );
      else if (!this.form.potHeight)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.potHeight"),
          })
        );
      else if (!this.form.frontGlassHeight)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.frontGlassHeight"),
          })
        );
      else if (!this.form.sideGlassHeight)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.sideGlassHeight"),
          })
        );
      else if (!this.form.metalWidth)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.metalWidth"),
          })
        );
      else if (!this.form.outdoorTemperature)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.outdoorTemperature"),
          })
        );
      else if (!this.form.cabinTemperature)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.cabinTemperature"),
          })
        );
      else if (!this.form.wallThickness)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.wallThickness"),
          })
        );
      else if (!this.form.insulationThickness)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.insulationThickness"),
          })
        );
      else if (!this.form.cabinHeight)
        return this.VALIDATION_ERROR_MESSAGE(
          this.$t("message.required.description", {
            field: this.$t("vincCalculating.cabinHeight"),
          })
        );
      return false;
    },
    async calculate(e, loading) {
      const validation = this.validation();
      if (validation) return;
      loading(true);
      const response = await Requests.CraneHVACC.Calculate({
        potDiameter: Number(this.form.potDiameter),
        potHeight: Number(this.form.potHeight),
        frontGlassHeight: Number(this.form.frontGlassHeight),
        sideGlassHeight: Number(this.form.sideGlassHeight),
        metalWidth: Number(this.form.metalWidth),
        outdoorTemperature: Number(this.form.outdoorTemperature),
        cabinTemperature: Number(this.form.cabinTemperature),
        wallThickness: Number(this.form.wallThickness),
        insulationThickness: Number(this.form.insulationThickness),
        cabinHeight: Number(this.form.cabinHeight),
      });
      if (response.message === "OK") {
        this.result = { ...response.data, status: true };
        setTimeout(() => {
          document
            .getElementById("result")
            .scrollIntoView({ behavior: "smooth", block: "center" });
        }, 1000);
      } else {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t(`message.${response.message}.description`)
        );
      }
      loading(false);
    },
    async save(e, loading) {
      const validation = this.validation();
      if (validation) return;
      loading(true);
      const response = await Requests.CraneHVACC.Create({
        title: this.title,
        potDiameter: Number(this.form.potDiameter),
        potHeight: Number(this.form.potHeight),
        frontGlassHeight: Number(this.form.frontGlassHeight),
        sideGlassHeight: Number(this.form.sideGlassHeight),
        metalWidth: Number(this.form.metalWidth),
        outdoorTemperature: Number(this.form.outdoorTemperature),
        cabinTemperature: Number(this.form.cabinTemperature),
        wallThickness: Number(this.form.wallThickness),
        insulationThickness: Number(this.form.insulationThickness),
        cabinHeight: Number(this.form.cabinHeight),
      });
      if (response.message === "OK") {
        this.result = { status: false };
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("common.saveSuccess"),
          variant: "success",
          duration: 2500,
        });
        this.$router.push({
          name: "vinc-calculating-detail",
          params: { id: response.data },
        });
      } else {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t(`message.${response.message}.description`)
        );
      }
      loading(false);
    },
  },
};
</script>

<style></style>
